import { render, staticRenderFns } from "./IconSvgBookmark.vue?vue&type=template&id=68a16074&scoped=true&"
import script from "./IconSvgBookmark.vue?vue&type=script&lang=js&"
export * from "./IconSvgBookmark.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68a16074",
  null
  
)

export default component.exports